import { Country } from './country';

import { countriesAll } from '@studyportals/static-domain-data/countries/countries';
import { countryGetIsoCode } from '@studyportals/static-domain-data/countries/country-get-iso-code';

class CountryPresenter {
	public all(): Promise<readonly Country[]> {
		const countries = countriesAll.map((c) => new Country(c.id, countryGetIsoCode(c.id) ?? '', c.name));

		return Promise.resolve(countries);
	}

	public async retrieveMultiple(ids: readonly string[]): Promise<readonly Country[]> {
		const countries = await this.all();
		const countriesRelevant = countries.filter((c) => ids?.includes(c.id));

		return Promise.resolve(countriesRelevant);
	}
}

export default new CountryPresenter();
